var React = require('react');
var { connect } = require('react-redux');
var PropTypes = require('prop-types');
var rolesManager = require('@managers/rolesManager');
var {
  getFieldArea,
  calculateDaysFromSeasonStart,
  last_kc,
} = require('fieldManager');

const { calculateSoilTemperatureValues } = require('soilDataManager');
const FieldDetailsMetricBox = require('FieldDetailsMetricBox');
var GeneralClasses = require('GeneralClasses');
var weatherManager = require('weatherManager');
var {
  upper,
  latestObjectfromDict,
  latestObjectFromDictWithKey,
  timeSinceNowString,
  latestTimeStampFromDict,
} = require('helpers');
var dayjs = require('../../utils/dayjsConfig');
var { withTranslation } = require('react-i18next');
var { unitDisplayName, convert } = require('unitsManager');
var {
  get_configuration_config,
  FeatureFlagDictionary,
} = require('remoteConfigurationsManager');
var IrrigationMeterDetailsContainer = require('IrrigationMeterDetailsContainer');

const MainCSS = require('mainCSS');
const FIELD_STATE_ARCHIVE = 'archive';

const IRRIGATION_SYSTEMS = [
  { title: 'Center-Pivot', value: 'centerPivot' },
  { title: 'Flood', value: 'flood' },
  { title: 'Furrow', value: 'furrow' },
  { title: 'N-Drip', value: 'ndrip' },
  { title: 'No Irrigation System', value: 'noIrrigationSystem' },
  { title: 'Pressurized Drip', value: 'pressurizedDrip' },
  { title: 'Sprinklers', value: 'sprinklers' },
  { title: 'Seepage', value: 'seepage' },
  { title: 'Linear', value: 'linear' },
  { title: 'Moving Laterals', value: 'moving laterals' },
];

class ExtendedFieldDetails extends React.Component {
  constructor(props) {
    super(props);
    this.calculateArea = this.calculateArea.bind(this);
  }

  componentDidMount() {}

  componentWillUnmount() {}

  calculateArea(areas) {
    // calculate area
    let fieldArea = getFieldArea(areas);
    let fieldAreaConverted = convert(
      fieldArea,
      'dunam',
      this.props.userData.area,
      'area',
    );
    return fieldAreaConverted;
  }

  render() {
    const { t } = this.props;
    const isArchiveMode = this.props.field_state === FIELD_STATE_ARCHIVE;
    let cropTitle = '';
    let lastET0Value = '';
    let lastKC = '0';
    let expirationDate = '';
    let soilType = '';
    let fieldArea = '';
    let accumulatedGDDValue = 0;
    let fert_height = '';
    let fert_last_seen = '';
    let fert_volume = '';
    let daysInSeason = '';
    let SoilTemperatureValues = '';
    let lastSoilTemperatureDate = '';
    let lastSoilAverageTemperature = '';
    let lastSoilMaxTemperature = '';
    let soilTempSensorsList = [];
    let lastKcOptimized = '';
    let lastKcOptimizedTs = '';
    let irrigationTypeTitle = '';
    const isNdripUser = rolesManager.isNdripUser(
      this.props.user_details?.email,
    );

    if (
      this.props.selectedField &&
      this.props.selectedField.crop_data.sow_date
    ) {
      daysInSeason = calculateDaysFromSeasonStart(
        this.props.selectedField.crop_data.sow_date,
      );
    }
    let alert = <div></div>;

    if (this.props.selectedField) {
      const rawIrrigationType =
        this.props.selectedField.irrigation_system?.irrigation_type;
      if (rawIrrigationType) {
        const found = IRRIGATION_SYSTEMS.find(
          (s) => s.value === rawIrrigationType,
        );
        irrigationTypeTitle = found ? found.title : rawIrrigationType;
      }

      if (this.props.selectedField.geo_data.area_size === undefined) {
        fieldArea = this.calculateArea(this.props.selectedField.geo_data.areas);
      } else {
        fieldArea = this.props.selectedField.geo_data.area_size;
      }

      if (this.props.selectedField.crop_data.crop_variety !== '') {
        cropTitle =
          upper(t(this.props.selectedField.crop_data.crop_type)) +
          '/' +
          upper(this.props.selectedField.crop_data.crop_variety);
      } else {
        cropTitle = upper(t(this.props.selectedField.crop_data.crop_type));
      }

      soilTempSensorsList = Object.keys(
        this.props.selectedField.sensors,
      ).filter(
        (currentSensor) =>
          this.props.selectedField.sensors[currentSensor] instanceof
          GeneralClasses.SoilTempSensor,
      );
      if (
        soilTempSensorsList.length > 0 &&
        this.props.selectedField.historical_data?.soil_temp?.values
      ) {
        [lastSoilTemperatureDate, SoilTemperatureValues] =
          latestObjectFromDictWithKey(
            this.props.selectedField.historical_data?.soil_temp?.values,
          );
        lastSoilTemperatureDate = timeSinceNowString(
          dayjs.unix(lastSoilTemperatureDate),
        );

        if (SoilTemperatureValues === undefined) {
          SoilTemperatureValues = 'N/A';
        }
        let lastSoilAverageValues = calculateSoilTemperatureValues(
          this.props.selectedField.historical_data.soil_temp?.values,
        );
        lastSoilAverageTemperature = lastSoilAverageValues.average;
        lastSoilMaxTemperature = lastSoilAverageValues.max;

        // combine all values in one str
        SoilTemperatureValues =
          lastSoilAverageTemperature +
          ' / ' +
          lastSoilMaxTemperature +
          ' / ' +
          SoilTemperatureValues;
      }
      if (
        this.props.selectedField.historical_data &&
        'et0' in this.props.selectedField.historical_data
      ) {
        let et0Statistics = weatherManager.weatherDataStatistics(
          this.props.selectedField.historical_data.et0.values,
          this.props.selectedField.geo_data.time_zone,
        );

        let startOfDay = dayjs()
          .tz(this.props.selectedField.geo_data.time_zone)
          .startOf('day')
          .unix();

        // in case we dont have today value, we will show yesterdays
        let yesterdayStartOfDay = dayjs()
          .tz(this.props.selectedField.geo_data.time_zone)
          .startOf('day')
          .subtract(1, 'd')
          .unix();

        if (startOfDay in et0Statistics) {
          // Taking the last value of the day - server already returns in correct units
          lastET0Value = parseFloat(
            et0Statistics[startOfDay]['lastValue'],
          ).toFixed(2);
        } else if (yesterdayStartOfDay in et0Statistics) {
          // Server already returns in correct units
          lastET0Value = parseFloat(
            et0Statistics[yesterdayStartOfDay]['lastValue'],
          ).toFixed(2);
        }

        var lastKCResult = last_kc(this.props.selectedField);
        lastKC = parseFloat(lastKCResult[0]).toFixed(2);
        if (
          this.props.selectedField &&
          this.props.selectedField.historical_data?.kc_optimized_phases
        ) {
          lastKcOptimizedTs = latestTimeStampFromDict(
            this.props.selectedField.historical_data?.kc_optimized_phases
              ?.values,
          );
        }

        if (lastKcOptimizedTs) {
          lastKcOptimized = parseFloat(
            this.props.selectedField.historical_data.kc_optimized_phases.values[
              lastKcOptimizedTs
            ],
          ).toFixed(2);
        }
      }
      expirationDate = this.props.selectedField.contract_data?.expiration_date
        ? dayjs
            .unix(this.props.selectedField.contract_data.expiration_date)
            .format('D MMM, YYYY')
        : 'N/A';

      soilType = this.props.selectedField.soil_type;

      if (
        this.props.selectedField.historical_data &&
        this.props.selectedField.historical_data.accu_gdd
      ) {
        accumulatedGDDValue = latestObjectfromDict(
          this.props.selectedField.historical_data.accu_gdd.values,
        );
      }

      if (
        get_configuration_config(
          this.props.configuration_data,
          FeatureFlagDictionary.FERT_TANK_HEIGHT,
          this.props.selectedFarmingUnit.name,
          this.props.selectedDistribution.name,
        ) &&
        this.props.selectedField.historical_data &&
        this.props.selectedField.historical_data.fert_height &&
        Object.keys(this.props.selectedField.historical_data.fert_height.values)
          .length > 0
      ) {
        //TODO: this is hard codded to cm, as it a POC and the algorithm calculate for cm only
        let [date, value] = latestObjectFromDictWithKey(
          this.props.selectedField.historical_data.fert_height.values,
        );
        fert_last_seen = timeSinceNowString(dayjs.unix(date));
        fert_height = parseFloat(value).toFixed(2) + ' cm';
      }
      if (
        get_configuration_config(
          this.props.configuration_data,
          FeatureFlagDictionary.FERT_TANK_VOLUME,
          this.props.selectedFarmingUnit.name,
          this.props.selectedDistribution.name,
        ) &&
        this.props.selectedField.historical_data &&
        this.props.selectedField.historical_data.fert_volume &&
        Object.keys(this.props.selectedField.historical_data.fert_volume.values)
          .length > 0
      ) {
        //TODO: this is hard codded to cm, as it a POC and the algorithm calculate for cm only
        fert_volume =
          parseFloat(
            latestObjectfromDict(
              this.props.selectedField.historical_data.fert_volume.values,
            ),
          ).toFixed(2) + ' L';
      }
    }

    const metrics = [
      {
        condition: true,
        label: 'crop_type',
        value: cropTitle,
        unit: '',
      },
      {
        condition: true,
        label: 'area',
        value: fieldArea,
        unit: unitDisplayName(this.props.userData.area),
      },
      {
        condition: irrigationTypeTitle !== '',
        label: 'irrigation_type',
        value: irrigationTypeTitle,
        unit: '',
      },
      {
        condition:
          this.props.field_state === 'active' && lastKC && !isNaN(lastKC),
        label: 'kc',
        value: lastKC,
        unit: '',
        onHover: lastKcOptimized,
        onHoverLabel: 'kc_optimized',
        hoverCondition: isNdripUser,
      },
      {
        condition: this.props.field_state === 'active' && lastET0Value,
        label: 'et0',
        value: lastET0Value,
        unit: unitDisplayName(
          this.props.selectedField?.historical_data?.et0?.units,
        ),
      },
      {
        condition: true,
        label: 'soil_type',
        value: t(upper(soilType)),
        unit: '',
      },
      {
        condition: soilTempSensorsList.length > 0,
        label: 'soil_temperature_values',
        value: SoilTemperatureValues,
        unit:
          SoilTemperatureValues !== 'N/A'
            ? unitDisplayName(this.props.userData.temperature)
            : '',
        lastSeen: lastSoilTemperatureDate,
        appearWithEmptyValue: true,
      },
      {
        condition: accumulatedGDDValue,
        label: 'gdd',
        value: accumulatedGDDValue,
        unit: unitDisplayName(
          this.props.selectedField?.historical_data?.accu_gdd?.units,
        ),
      },
      {
        condition: fert_height && fert_height !== '',
        label: 'fert_tank_height',
        value: fert_height,
        unit: '',
        lastSeen: fert_last_seen,
      },
      {
        condition: fert_volume && fert_volume !== '',
        label: 'Fert_tank_volume',
        value: fert_volume,
        unit: '',
        lastSeen: fert_last_seen,
      },
      {
        condition:
          this.props.field_state === 'active' && daysInSeason !== undefined,
        label: 'Field_details_days_in_season',
        value: daysInSeason + ' ' + t('days'),
        unit: '',
      },
      {
        condition: true,
        label: 'expiration_date',
        value: expirationDate,
        unit: '',
      },
    ];
    return (
      <div>
        <div
          className='d-flex flex-row bg-white w-100 fieldDetails fieldDetailsLargeScreens'
          style={{
            borderTopLeftRadius: '15px',
            borderTopRightRadius: '15px',
            lineHeight: '40px',
          }}
        >
          {!isArchiveMode && (
            <div
              className='d-flex align-items-center IrrigationMeterDetailsContainer'
              style={{
                borderLeft: '1px solid #DCE0E8',
                borderBottom: '0.5px solid #DCE0E8',
                borderTop: '0.5px solid #DCE0E8',
                borderTopLeftRadius: '14px',
              }}
            >
              <IrrigationMeterDetailsContainer />
            </div>
          )}
          <div
            className='d-flex justify-content-around flex-wrap w-100 FieldDetailsContainer'
            style={{
              borderRight: '1px solid #DCE0E8',
              borderTop: '0.5px solid #DCE0E8',
              ...(isArchiveMode && {
                borderLeft: '1px solid #DCE0E8',
                borderTopLeftRadius: '15px',
              }),
            }}
          >
            {metrics.map(
              (
                {
                  condition,
                  label,
                  value,
                  unit,
                  lastSeen,
                  onHover,
                  onHoverLabel,
                  hoverCondition,
                },
                index,
              ) =>
                condition ? (
                  <FieldDetailsMetricBox
                    key={index}
                    label={label}
                    value={value}
                    unit={unit}
                    fieldState={this.props.field_state}
                    lastSeen={lastSeen}
                    onHover={onHover}
                    onHoverLabel={onHoverLabel}
                    hoverCondition={hoverCondition}
                  />
                ) : null,
            )}
          </div>
          {alert}
        </div>
      </div>
    );
  }
}

ExtendedFieldDetails.propTypes = {
  field_state: PropTypes.string.isRequired,
};

const mapStateToProps = function (state) {
  return {
    userData: state.authentication_data.user_data,
    selectedField: state.distribution_data.selected_entities.field,
    loadHistoryStatus: state.distribution_data.field_load_history,
    field_state: state.distribution_data.field_state,
    configuration_data: state.configuration_data,
    selectedFarmingUnit: state.distribution_data.selected_entities.farming_unit,
    selectedDistribution:
      state.distribution_data.selected_entities.distribution,
    user_details: state.authentication_data.user_details,
  };
};

const mapDispatchToProps = {};

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(ExtendedFieldDetails));
